const images = {
  landingBackground: require("../Assets/Images/bg1.jpg"),
  cmmsLogo: require("../Assets/Images/logo.png"),
  defaultAvatar: require("../Assets/Images/default-avatar.svg"),
  illustrationOne: require("../Assets/Images/main_1.jpg"),
  illustrationTwo: require("../Assets/Images/main_2.jpg"),
  illustrationThree: require("../Assets/Images/main_3.jpg"),
  mockupOne: require("../Assets/Images/mockup1.png"),
  mockupTwo: require("../Assets/Images/mockup2.png"),
  mockupThree: require("../Assets/Images/mockup3.png"),
  promaint: require("../Assets/Images/clients/promaint.png") // client
};

export default images;



// WEBPACK FOOTER //
// ./src/Themes/Images.ts